import { OwAccordion } from "@components/shared/OwAccordion/OwAccordion";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import WhatsThis from "@components/shared/WhatsThis/WhatsThis";
import SupplierContext from "@contexts/SupplierContext";
import ICatalog from "@models/ICatalog";
import IPrice_Group from "@models/IPrice_Group";
import QBDCompanyFieldForOWCompanyNameEnum from "@models/QBDCompanyFieldForOWCompanyNameEnum";
import TitleTagEnum from "@models/TitleTagEnum";
import _ from "lodash";
import React, { useContext, useState } from "react";

type Props = {
    handleChange: (e: React.ChangeEvent<any>) => void;
    borderClass: string;
    catalogs: ICatalog[];
};

export const QuickbooksDesktopConfigCustomersSection = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [supplierIntegration, setSupplierIntegration] = useState({
        qbd_TermOptions: supplierModel.Supplier_Integration.qbd_TermOptions,
        qbd_NoPriceLevelCatalogId: supplierModel.Supplier_Integration.qbd_NoPriceLevelCatalogId,
        qbd_NoPriceLevelPriceGroupId: supplierModel.Supplier_Integration.qbd_NoPriceLevelPriceGroupId,
        qbd_CompanyFieldForOwCompanyName: supplierModel.Supplier_Integration.qbd_CompanyFieldForOwCompanyName,
        qbd_address_shift: supplierModel.Supplier_Integration.qbd_address_shift,
        qbd_AutoPullAndProcessCustomers: supplierModel.Supplier_Integration.qbd_AutoPullAndProcessCustomers,
        qbd_AllowCreateCustomers: supplierModel.Supplier_Integration.qbd_AllowCreateCustomers,
        qbd_AllowUpdateCustomers: supplierModel.Supplier_Integration.qbd_AllowUpdateCustomers,
        qbd_CreateRepGroupsFromRepDetails: supplierModel.Supplier_Integration.qbd_CreateRepGroupsFromRepDetails,
        qbd_AutoAssignAccountsToRepGroup: supplierModel.Supplier_Integration.qbd_AutoAssignAccountsToRepGroup,
    });

    const { qbd_TermOptions } = supplierModel.Supplier_Integration;

    const termOptions = _.isString(qbd_TermOptions) ? JSON.parse(qbd_TermOptions || "") : qbd_TermOptions;

    const companyNameFieldOptions = [
        { value: QBDCompanyFieldForOWCompanyNameEnum.NAME, title: "Name" },
        { value: QBDCompanyFieldForOWCompanyNameEnum.COMPANY_NAME, title: "Company Name" },
        { value: QBDCompanyFieldForOWCompanyNameEnum.FULL_NAME, title: "Full Name" },
    ];

    let noPriceLevelPriceGroups: IPrice_Group[] = [];

    if (supplierIntegration.qbd_NoPriceLevelCatalogId) {
        for (const catalog of props.catalogs) {
            if (catalog.id === Number(supplierIntegration.qbd_NoPriceLevelCatalogId)) {
                noPriceLevelPriceGroups = catalog.Price_Groups || [];
            }
        }
    }

    const handleChange = (e: React.ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const updatedSupplierIntegration = {
            ...supplierIntegration,
            [name]: value,
        };

        setSupplierIntegration(updatedSupplierIntegration);

        props.handleChange(e);
    };

    return (
        <div className={"QuickbooksDesktopConfigCustomersSection mb-2"}>
            <OwAccordion title={"customers"} fullWidthClick={true} titleTag={TitleTagEnum.H5}>
                <div className={"col-12 card " + props.borderClass} data-id={"qbd-customers-card"}>
                    <div className={"card-header"}>
                        <OwTitle title={"customers"} isBold={true} tag={"h5"} />
                    </div>

                    <div className="card-body">
                        <div className={""}>
                            <OwTitle title={"term_options"} tag={"h6"} isBold={true} />
                            <WhatsThis subject={"qbd_term_options_info"} />
                            <div>
                                <OwSelectOption
                                    valueProp={"ListID"}
                                    fn={handleChange}
                                    name={"qbd_DefaultTerm"}
                                    options={termOptions}
                                    titleProp={"Name"}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_DefaultTerm"}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>
                        <div className="mt-4">
                            <div>
                                <OwLabel isBold={true} title={"account_no_price_level_set_catalog_price_group"} />
                                <WhatsThis subject={"qbd_account_no_price_level_set_catalog_price_group"} />
                            </div>
                            <div>
                                <div>
                                    <OwSelectOption
                                        name={"qbd_NoPriceLevelCatalogId"}
                                        options={props.catalogs}
                                        fn={handleChange}
                                        titleProp={"name"}
                                        valueProp={"id"}
                                        selectedOption={supplierIntegration}
                                        selectedOptionProp={"qbd_NoPriceLevelCatalogId"}
                                    />
                                </div>

                                <div className={"mt-2"}>
                                    <OwSelectOption
                                        name={"qbd_NoPriceLevelPriceGroupId"}
                                        options={noPriceLevelPriceGroups}
                                        fn={handleChange}
                                        titleProp={"value"}
                                        valueProp={"id"}
                                        selectedOption={supplierIntegration}
                                        selectedOptionProp={"qbd_NoPriceLevelPriceGroupId"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <div>
                                <OwLabel title={"company_name_property"} />
                                <WhatsThis subject={"qbd_company_name_property"} />
                            </div>
                            <div>
                                <OwSelectOption
                                    fn={handleChange}
                                    name={"qbd_CompanyFieldForOwCompanyName"}
                                    options={companyNameFieldOptions}
                                    selectedOption={supplierIntegration}
                                    selectedOptionProp={"qbd_CompanyFieldForOwCompanyName"}
                                    valueProp={"value"}
                                    titleProp={"title"}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwToggle
                                fn={handleChange}
                                name={"qbd_address_shift"}
                                label={"address_shift"}
                                active={supplierIntegration.qbd_address_shift || false}
                                labelOnRight={true}
                            />
                        </div>

                        <WhatsThis subject={"qbd_allow_create_customer"} className={"mt-4"} />
                        <div>
                            <OwToggle
                                fn={handleChange}
                                name={"qbd_AutoPullAndProcessCustomers"}
                                label={"auto_pull_and_process_customers"}
                                active={!!supplierIntegration.qbd_AutoPullAndProcessCustomers}
                            />
                        </div>
                        <div>
                            <OwToggle
                                fn={handleChange}
                                name={"qbd_AllowCreateCustomers"}
                                label={"allow_create_customer"}
                                active={supplierIntegration.qbd_AllowCreateCustomers || false}
                                labelOnRight={true}
                            />
                        </div>
                        <WhatsThis subject={"qbd_allow_customer_updates"} />
                        <div>
                            <OwToggle
                                fn={handleChange}
                                name={"qbd_AllowUpdateCustomers"}
                                label={"allow_customer_updates"}
                                active={supplierIntegration.qbd_AllowUpdateCustomers || false}
                                labelOnRight={true}
                            />
                        </div>

                        {supplierModel.has_rep_groups ? (
                            <div className={"mt-4"}>
                                <WhatsThis subject={"qbd_auto_create_rep_groups"} />
                                <div>
                                    <OwToggle
                                        fn={handleChange}
                                        name={"qbd_CreateRepGroupsFromRepDetails"}
                                        label={"auto_create_rep_groups"}
                                        active={supplierIntegration.qbd_CreateRepGroupsFromRepDetails || false}
                                        labelOnRight={true}
                                    />
                                </div>
                            </div>
                        ) : null}

                        {supplierModel.has_rep_groups ? (
                            <div className={"mt-4"}>
                                <WhatsThis subject={"qbd_auto_assign_accounts_to_rep_group"} />
                                <div>
                                    <OwToggle
                                        fn={handleChange}
                                        name={"qbd_AutoAssignAccountsToRepGroup"}
                                        label={"auto_assign_accounts_to_rep_group"}
                                        active={supplierIntegration.qbd_AutoAssignAccountsToRepGroup || false}
                                        labelOnRight={true}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
